import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;

  ${mediaMaxWidth.phone} {
    margin: 10px 0;
  }
`;

export const Title = styled.div`
  border-bottom: 1px solid #d8d8d8;
  color: #333;
  font-weight: 600;
  font-size: 1em;
  padding: 10px;
  display: inline-block;
  width: calc(100% - 40px);
  position: absolute;
  top: 10px;
  margin: 0 10px;
  left: 0;
  font-weight: 400;

  strong {
    margin: 0 5px;
  }

  ${mediaMaxWidth.phone} {
    font-size: 0.9em;
    padding: 10px 5px;

    strong {
      margin: 0 3px;
    }
  }
`;

interface IParagraphProps {
  welcome?: boolean;
  thankYouOne?: boolean;
  thankYouTwo?: boolean;
  reviewLeft?: boolean;
  small?: boolean;
  center?: boolean;
}

export const Paragraph = styled.p`
  margin: ${(props: IParagraphProps) => (props.welcome ? "10px 0" : "15px 0")};
  margin: ${(props: IParagraphProps) => props.thankYouOne && "70px 0 25px 0"};
  margin: ${(props: IParagraphProps) => props.thankYouTwo && "25px 0 110px 0"};
  margin: ${(props: IParagraphProps) => props.reviewLeft && "25px 0"};
  font-size: 1.25em;
  font-size: ${(props: IParagraphProps) => props.small && "0.9em"};
  font-size: ${(props: IParagraphProps) => props.reviewLeft && "1.6em"};
  font-weight: 100;
  text-align: ${(props: IParagraphProps) => props.center && "center"};
  letter-spacing: ${(props: IParagraphProps) => props.small && "0.5px"};

  strong {
    font-weight: 600;
  }

  ${mediaMaxWidth.phone} {
    margin: ${(props: IParagraphProps) =>
      props.welcome ? "20px 0 15px 0" : "10px 0"};
    margin: ${(props: IParagraphProps) => props.thankYouOne && "60px 0 15px 0"};
    margin: ${(props: IParagraphProps) =>
      props.thankYouTwo && "15px 0 100px 0"};
    margin: ${(props: IParagraphProps) => props.reviewLeft && "15px 0"};
    font-size: 1.15em;
    font-size: ${(props: IParagraphProps) => props.small && "1em"};
    font-size: ${(props: IParagraphProps) => props.reviewLeft && "1.5em"};
  }
`;

export const SmallPrint = styled.p`
  font-size: 0.9em;
  font-style: italic;
  text-align: center;
  margin: 20px auto 40px auto;
`;

export const Link = styled.a`
  color: #fff;
  text-decoration: underline;
  font-size: 1em;
`;

export const CheckboxLabel = styled.label`
  position: relative;
  cursor: pointer;
  padding: 5px 0 0 30px;
  font-size: 0.95em;
  font-weight: 100;
`;

export const Checkbox = styled.input`
  padding: 0;
  height: initial;
  width: initial;
  margin-bottom: 0;
  display: none;
  cursor: pointer;
`;

export const ChecboxWrapper = styled.div`
  display: flex;
  margin: 15px 0;

  label:before {
    content: "";
    -webkit-appearance: none;
    background-color: #989898;
    border: 2px solid #fff;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
      inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);
    padding: 8px;
    display: inline-block;
    position: relative;
    vertical-align: middle;
    cursor: pointer;
    margin-right: 5px;
    border-radius: 4px;
    position: absolute;
    left: 0;
    top: 3px;

    ${mediaMaxWidth.phone} {
      top: 7px;
    }
  }

  input:checked + label:after {
    content: "";
    display: block;
    position: absolute;
    top: 4px;
    left: 6px;
    width: 5px;
    height: 13px;
    border: solid #fff;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);

    ${mediaMaxWidth.phone} {
      top: 7px;
    }
  }

  input:checked + label:before {
    background-color: #79D9D9;
    border: 2px solid #79D9D9;
  }

  ${mediaMaxWidth.phone} {
    bottom: 90px;
  }
`;

export const FakeNextButton = styled.button`
  margin: 20px auto;
  background-color: #989898;
  color: #fff;
  font-size: 1.125rem;
  line-height: 3.25rem;
  font-family: Komet;
  font-weight: 900;
  border-radius: 9px;
  border: 1px solid #fff;
  cursor: not-allowed;
  box-shadow: 0 1px 3px rgba(1, 1, 1, 0.5);
  transition: ease-in-out 0.1s;
  width: 130px;
  text-align: center;
  width: 185px;

  ${mediaMaxWidth.phone} {
    line-height: 2.9rem;
  }
`;

export const NextButton = styled.button`
  margin: 20px auto;
  background-color: #402680;
  color: #79D9D9;
  font-size: 1.125rem;
  line-height: 3.25rem;
  font-family: Komet;
  font-weight: 900;
  border-radius: 9px;
  border: 1px solid #402680;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(1, 1, 1, 0.5);
  transition: ease-in-out 0.1s;
  width: 130px;
  text-align: center;
  width: 185px;

  &:hover {
    background: #fff;
    border: 1px solid #79D9D9;
  }

  ${mediaMaxWidth.phone} {
    line-height: 2.9rem;
  }
`;

export const Input = styled.input``;

export const Label = styled.label``;

export const ReviewTitle = styled.div`
  display: flex;
  justify-content: center;
  font-weight: 700;
  letter-spacing: 1px;
  font-size: 1.1em;
  color: #333;
  height: 80px;
  align-items: center;
  width: 300px;
  word-break: break-word;
  text-align: center;

  ${mediaMaxWidth.phone} {
    font-size: 1em;
  }

  ${mediaMaxWidth.smallPhone} {
    width: 240px;
    font-size: 0.95em;
  }
`;

export const StepCount = styled.div`
  position: absolute;
  bottom: 35px;
  right: 30px;
  font-size: 0.8em;
  color: #333;

  ${mediaMaxWidth.phone} {
    right: 20px;
    bottom: 25px;
  }
`;

export const Rating = styled.div`
  display: flex;
  width: 300px;
  justify-content: center;
  flex-direction: row-reverse;
  position: relative;
  margin-top: 10px;

  ${Input}:checked ~ ${Label}, ${Input}:checked ~ ${Label} ~ ${Label} {
    &:after {
      content: "\f005";
      font-family: FontAwesome;
      color: #79D9D9;
      font-size: 2em;
    }
  }

  ${Input}:not(:checked) ~ ${Label}:hover ~ ${Label} {
    &:after {
      content: "\f005";
      font-family: FontAwesome;
      color: #79D9D9;
      font-size: 2em;
    }
  }

  ${Input}:not(:checked) ~ ${Label}:hover {
    &:after {
      content: "\f005";
      font-family: FontAwesome;
      color: #79D9D9;
      font-size: 2em;
    }
  }
`;

interface IRatingStepWrapperProps {
  noPointerEvents?: number;
}

export const RatingStepWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: 50px;
  pointer-events: ${(props: IRatingStepWrapperProps) =>
    props.noPointerEvents !== null && "none"};
  pointer-events: ${(props: IRatingStepWrapperProps) =>
    props.noPointerEvents === 5 && "auto"};
  background-color: #fff;
  width: 600px;
  position: relative;
  height: 405px;
  border-radius: 8px;
  overflow: hidden;

  ${Rating} > ${Input} {
    display: none;
  }

  ${Rating} > ${Label} {
    cursor: pointer;
    width: 45px;
    height: 35px;
    transition: 0.3s;

    &:after {
      content: "\f005";
      font-family: FontAwesome;
      color: lightgray;
      font-size: 2em;
      transition: 0.1s;
    }
  }

  ${mediaMaxWidth.tablet} {
    width: 500px;
  }

  ${mediaMaxWidth.phone} {
    margin-top: 20px;
    width: calc(100vw - 40px);
  }
`;

export const Field = styled.div`
  position: relative;
  display: flex;
`;

export const TextInput = styled.textarea`
  display: flex;
  border: 2px solid #e7e7e7;
  border-radius: 8px;
  width: 400px;
  resize: none;
  padding: 10px;
  height: 12em;
  position: relative;
  color: #333;
  font-size: 1em;
  position: relative;
  top: -20px;

  &::placeholder {
    font-style: italic;
    font-weight: 300;
    font-size: 0.9em;
  }

  &:focus {
    border-color: #79D9D9;
    outline: none;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(233, 102, 163, 0.6);
  }

  ${mediaMaxWidth.phone} {
    width: calc(100vw - 70px);
  }
`;

export const Note = styled.div`
  position: absolute;
  bottom: 105px;
  font-size: 0.75em;
  width: 100%;
  text-align: center;
  color: #989898;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    margin-right: 3px;
  }
`;

export const SubmitButton = styled.button`
  position: absolute;
  bottom: 30px;
  right: 0;
  left: 0;
  margin: 0 auto;
  background-color: #79D9D9;
  color: #fff;
  font-size: 1.125rem;
  line-height: 3.25rem;
  font-family: Komet;
  font-weight: 900;
  border-radius: 9px;
  border: 1px solid #79D9D9;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(1, 1, 1, 0.5);
  transition: ease-in-out 0.1s;
  width: 130px;
  text-align: center;

  &:hover {
    background: #b70d6c;
    border: 1px solid #b70d6c;
  }

  ${mediaMaxWidth.phone} {
    width: 110px;
    line-height: 2.9rem;
  }
`;

export const FakeSubmitButton = styled.button`
  position: absolute;
  bottom: 30px;
  right: 0;
  left: 0;
  margin: 0 auto;
  background-color: #989898;
  color: #fff;
  font-size: 1.125rem;
  line-height: 3.25rem;
  font-family: Komet;
  font-weight: 900;
  border-radius: 9px;
  border: 1px solid #989898;
  cursor: not-allowed;
  box-shadow: 0 1px 3px rgba(1, 1, 1, 0.5);
  transition: ease-in-out 0.1s;
  width: 130px;
  text-align: center;

  ${mediaMaxWidth.phone} {
    width: 110px;
    line-height: 2.9rem;
  }
`;
